// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1396":"e1e18b8d","1576":"4a4c4488","3545":"e1e18b8d","6534":"ce99d352"}[chunkId] + ".chunk.css";
};